import AsyncSelect from 'react-select/async'
import { type ReactElement, useEffect } from 'react'
import { useSnapshot } from 'valtio'
import {
  AddCustomerButton
} from '../../../virtual-terminal/index/Payment/PaymentDetails/CustomerSection/components/AddCustomerButton'
import { recurringPaymentNewProxy } from '../recurringPaymentNewProxy'
import { resetCreditCardAddProxy } from '../../../../../shared/proxies/creditCardListProxy'
import { throttledLoadOptions, handleChange, buildOption } from './utils'

export default function RecurringConfigurationCustomerSection (): ReactElement {
  useEffect(() => resetCreditCardAddProxy, [])
  const { customer } = useSnapshot(recurringPaymentNewProxy)

  return (
    <div className="grid grid-cols-1 mx-2">
      <div className="flex flex-col w-full">
        <label>Customer</label>
        <div className="flex flex-row">

          <AsyncSelect
            key={customer?.id}
            isClearable
            className="flex-grow mr-4 border border-wpy-gray rounded-md"
            defaultOptions
            loadOptions={throttledLoadOptions}
            onChange={handleChange}
            placeholder="Select Customer"
            styles={{
              control: (provided) => ({
                ...provided,
                border: 0,
                height: '100%'
              })
            }}
            tabSelectsValue
            value={customer ? buildOption(customer) : null}
          />

          <AddCustomerButton />
        </div>
      </div>
    </div>
  )
}
